<template>
  <div id="box" class="father-order-page">
    <div class="historyTag">
      <historyTag :historyArr="historyArr"></historyTag>
    </div>

    <div class="filter-box">
      <el-form :inline="true" size="small" @submit.native.prevent="searchFn">
        <el-form-item label="单号">
          <el-input v-model.trim="query.orderNo" clearable placeholder="父单号 / 子单号" style="width: 200px" @keyup.enter.native="searchFn" />
        </el-form-item>
        <el-form-item label="用户">
          <el-input v-model.trim="query.userIdStr" clearable placeholder="用户 ID" style="width: 120px" @keyup.enter.native="searchFn" />
        </el-form-item>
        <el-form-item label="业务">
          <el-select v-model="query.bizType" clearable placeholder="全部" style="width: 100px">
            <el-option label="全部" value="ALL" />
            <el-option label="鉴别" value="IDENTIFY" />
            <el-option label="寄售" value="CONSIGN" />
          </el-select>
        </el-form-item>
        <el-form-item label="支付">
          <el-select v-model="query.ispay" clearable placeholder="全部" style="width: 100px">
            <el-option label="未支付" :value="0" />
            <el-option label="已支付" :value="1" />
          </el-select>
        </el-form-item>
        <el-form-item label="运费">
          <el-select v-model="query.freightPayMode" clearable placeholder="全部" style="width: 120px">
            <el-option label="预付合单" value="PREPAY" />
            <el-option label="取件后付" value="POST_PICK" />
          </el-select>
        </el-form-item>
        <el-form-item label="创建时间">
          <el-date-picker
            v-model="query.dateRange"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始"
            end-placeholder="结束"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
            style="width: 340px"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="searchFn">搜索</el-button>
          <el-button @click="resetFn">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <el-table :data="tableData" border v-loading="loading" style="width: 100%" :header-cell-style="{ background: '#fafafa' }">
      <el-table-column label="父订单号" min-width="220">
        <template slot-scope="scope">
          <div class="order-no" @click="copyText(scope.row.orderid)">{{ scope.row.orderid || "—" }}</div>
          <div class="sub-row">
            <el-tag v-if="freightModeLabel(scope.row)" size="mini" type="info" effect="plain">{{ freightModeLabel(scope.row) }}</el-tag>
            <el-tag v-if="scope.row.pickupBookingStatus === 'FAILED'" size="mini" type="danger" effect="plain">预约失败</el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="用户" min-width="168">
        <template slot-scope="scope">
          <div class="user-cell">
            <img
              v-if="scope.row.userPhoto"
              class="user-avatar-img"
              :src="scope.row.userPhoto"
              alt=""
            />
            <div v-else class="user-avatar-fallback">{{ userInitial(scope.row) }}</div>
            <div class="user-meta">
              <div class="user-name" :title="scope.row.userNickName || ''">
                {{ scope.row.userNickName || "未设置昵称" }}
              </div>
              <div class="user-phone" v-if="scope.row.userPhone" @click="copyText(scope.row.userPhone)">
                {{ scope.row.userPhone }}
              </div>
              <div class="user-phone muted" v-else>—</div>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="业务" width="88" align="center">
        <template slot-scope="scope">
          <div>{{ scope.row.bizTypeLabel || "—" }}</div>
          <div class="sub">{{ scope.row.childCount != null ? scope.row.childCount + " 瓶" : "" }}</div>
        </template>
      </el-table-column>
      <el-table-column label="状态" width="108" align="center">
        <template slot-scope="scope">
          <el-tag :type="payTagType(scope.row)" size="mini" effect="plain">
            {{ scope.row.statusLabel || "—" }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="金额" min-width="128" align="right">
        <template slot-scope="scope">
          <div class="money-main">{{ money(scope.row.price) }}</div>
          <div class="sub">鉴别 {{ money(scope.row.inspectionAmount) }}</div>
          <div class="sub" v-if="Number(scope.row.pickupFreightAmount) > 0">
            运费 {{ money(scope.row.pickupFreightAmount) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="退款" min-width="120" align="right">
        <template slot-scope="scope">
          <div class="sub">已退 {{ money(scope.row.refundedAmount) }}</div>
          <div class="money-remain">可退 {{ money(scope.row.remainingRefundable) }}</div>
          <div class="sub" v-if="Number(scope.row.freightRemaining) > 0">
            运费可退 {{ money(scope.row.freightRemaining) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="创建时间" width="168" align="center">
        <template slot-scope="scope">{{ formatTime(scope.row.createtime) }}</template>
      </el-table-column>
      <el-table-column label="操作" width="110" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="openDetail(scope.row)">详情/退款</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pager">
      <el-pagination
        background
        layout="total, prev, pager, next, sizes"
        :total="total"
        :current-page.sync="query.page"
        :page-size.sync="query.size"
        :page-sizes="[20, 50, 100]"
        @current-change="loadList"
        @size-change="onSizeChange"
      />
    </div>

    <el-drawer
      :visible.sync="drawerVisible"
      size="900px"
      direction="rtl"
      :destroy-on-close="true"
      custom-class="father-detail-drawer"
      @closed="onDrawerClosed"
    >
      <div slot="title" class="drawer-title" v-if="detail">
        <div class="drawer-title-main">
          <span class="drawer-title-text">父级订单</span>
          <el-tag :type="payTagType(detail)" size="mini" effect="plain">{{ detail.statusLabel || "—" }}</el-tag>
          <el-tag v-if="freightModeLabel(detail)" size="mini" type="info" effect="plain">{{ freightModeLabel(detail) }}</el-tag>
          <el-tag v-if="detail.pickupBookingStatus === 'FAILED'" size="mini" type="danger" effect="plain">预约失败</el-tag>
        </div>
        <div class="drawer-title-no" @click="copyText(detail.orderid)">{{ detail.orderid || "—" }}</div>
      </div>
      <div slot="title" v-else>父级订单详情</div>

      <div v-loading="detailLoading" class="detail-wrap" v-if="detail">
        <div class="detail-user">
          <img
            v-if="detail.userPhoto"
            class="user-avatar-img"
            :src="detail.userPhoto"
            alt=""
          />
          <div v-else class="user-avatar-fallback">{{ userInitial(detail) }}</div>
          <div class="detail-user-meta">
            <div class="user-name">{{ detail.userNickName || "未设置昵称" }}</div>
            <div class="detail-user-sub">
              <span
                v-if="detail.userPhone"
                class="linkish"
                @click="copyText(detail.userPhone)"
              >{{ detail.userPhone }}</span>
              <span v-else class="muted">无手机号</span>
              <span class="dot">·</span>
              <span class="muted">创建 {{ formatTime(detail.createtime) }}</span>
            </div>
          </div>
          <div class="detail-user-side">
            <div class="side-label">业务瓶数</div>
            <div class="side-value">{{ detail.childCount != null ? detail.childCount : (detail.children || []).length }} 瓶</div>
          </div>
        </div>

        <div class="amount-bar">
          <div class="amt">
            <span>实付</span>
            <b>{{ money(detail.amounts && detail.amounts.paid) }}</b>
          </div>
          <div class="amt">
            <span>鉴别费</span>
            <b>{{ money(detail.amounts && detail.amounts.inspection) }}</b>
          </div>
          <div class="amt">
            <span>运费额度</span>
            <b>{{ money(detail.amounts && detail.amounts.freightCap) }}</b>
          </div>
          <div class="amt">
            <span>已退</span>
            <b>{{ money(detail.amounts && detail.amounts.refunded) }}</b>
          </div>
          <div class="amt amt-hl">
            <span>可退</span>
            <b>{{ money(detail.amounts && detail.amounts.remaining) }}</b>
          </div>
          <div class="amt">
            <span>运费可退</span>
            <b>{{ money(detail.amounts && detail.amounts.freightRemaining) }}</b>
          </div>
        </div>

        <div class="section-card">
          <div class="section-title">物流信息</div>
          <div class="info-grid">
            <div class="info-item">
              <span class="k">快递</span>
              <span class="v">
                <template v-if="detail.kdname || detail.kdno">
                  {{ detail.kdname || "—" }}
                  <span
                    v-if="detail.kdno"
                    class="linkish"
                    @click="copyText(detail.kdno)"
                  >{{ detail.kdno }}</span>
                </template>
                <template v-else>—</template>
              </span>
            </div>
            <div class="info-item">
              <span class="k">预约状态</span>
              <span class="v">{{ bookingStatusLabel(detail.pickupBookingStatus) }}</span>
            </div>
            <div class="info-item">
              <span class="k">寄件电话</span>
              <span
                class="v linkish"
                v-if="detail.senderPhone || detail.phone"
                @click="copyText(detail.senderPhone || detail.phone)"
              >{{ detail.senderPhone || detail.phone }}</span>
              <span class="v muted" v-else>—</span>
            </div>
            <div class="info-item">
              <span class="k">预约时间</span>
              <span class="v">{{ detail.yysj || "—" }}</span>
            </div>
            <div class="info-item info-item-full">
              <span class="k">取件地址</span>
              <span class="v">{{ formatPickupAddress(detail.qjdz) }}</span>
            </div>
            <div class="info-item info-item-full" v-if="detail.pickupBookingLastError">
              <span class="k">预约错误</span>
              <span class="v err">{{ detail.pickupBookingLastError }}</span>
            </div>
          </div>
        </div>

        <div class="actions">
          <el-button
            type="warning"
            size="small"
            :disabled="!(detail.amounts && detail.amounts.canRefundFreight)"
            :loading="refunding"
            @click="refundFreight"
          >退运费</el-button>
          <el-button
            type="danger"
            size="small"
            :disabled="!(detail.amounts && detail.amounts.canRefundAllRemaining)"
            :loading="refunding"
            @click="refundFatherFull"
          >整单退款</el-button>
          <el-button size="small" :loading="detailLoading" @click="reloadDetail">刷新</el-button>
        </div>

        <div class="section-card child-section">
          <div class="section-title">
            子单
            <span class="section-count">共 {{ childrenTotal }} 条</span>
            <span v-if="childrenList.length" class="section-count soft">本页 {{ childrenList.length }}</span>
          </div>
          <el-form :inline="true" size="mini" class="child-filter" @submit.native.prevent="searchChildren">
            <el-form-item label="子单号">
              <el-input
                v-model.trim="childFilter.orderId"
                clearable
                placeholder="模糊"
                style="width: 150px"
                @keyup.enter.native="searchChildren"
              />
            </el-form-item>
            <el-form-item label="香水">
              <el-input
                v-model.trim="childFilter.keyword"
                clearable
                placeholder="品牌 / 型号"
                style="width: 140px"
                @keyup.enter.native="searchChildren"
              />
            </el-form-item>
            <el-form-item label="类型">
              <el-select v-model="childFilter.bizType" clearable placeholder="全部" style="width: 100px" @change="searchChildren">
                <el-option label="鉴别" value="鉴别" />
                <el-option label="寄售" value="寄售" />
              </el-select>
            </el-form-item>
            <el-form-item label="状态">
              <el-select v-model="childFilter.statusKey" clearable placeholder="全部" style="width: 110px" @change="searchChildren">
                <el-option label="可退" value="refundable" />
                <el-option label="已关单" value="closed" />
                <el-option label="快速单" value="fast" />
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" :loading="childrenLoading" @click="searchChildren">搜索</el-button>
              <el-button @click="resetChildFilter">重置</el-button>
            </el-form-item>
          </el-form>
          <el-table
            ref="childrenTable"
            :data="childrenList"
            border
            size="mini"
            height="360"
            v-loading="childrenLoading"
            :header-cell-style="{ background: '#fafafa' }"
            class="child-table"
          >
            <el-table-column label="子单号" width="168">
              <template slot-scope="scope">
                <span class="linkish mono" @click="copyText(scope.row.orderId)">{{ scope.row.orderId || "—" }}</span>
              </template>
            </el-table-column>
            <el-table-column label="类型/状态" width="108" align="center">
              <template slot-scope="scope">
                <div class="tag-stack">
                  <el-tag size="mini" effect="plain">{{ scope.row.bizTypeLabel || "—" }}</el-tag>
                  <el-tag v-if="Number(scope.row.isFast) === 1" size="mini" type="warning" effect="plain">快速</el-tag>
                  <el-tag
                    size="mini"
                    effect="plain"
                    :type="Number(scope.row.isClosed) === 1 ? 'info' : 'success'"
                  >{{ Number(scope.row.isClosed) === 1 ? "已关单" : (scope.row.statusLabel || "—") }}</el-tag>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="香水" min-width="160">
              <template slot-scope="scope">
                <el-tooltip
                  effect="dark"
                  placement="top"
                  :disabled="!perfumeTip(scope.row)"
                  :content="perfumeTip(scope.row)"
                >
                  <div class="perfume-cell">
                    <div class="goods-brand">{{ brandTypeLabel(scope.row) }}</div>
                    <div v-if="scope.row.jbServiceName" class="sub truncate">{{ scope.row.jbServiceName }}</div>
                  </div>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="金额" width="96" align="right">
              <template slot-scope="scope">
                <div class="money-main">{{ money(lineFee(scope.row)) }}</div>
                <div class="sub" v-if="Number(scope.row.extraJbAmount) > 0">
                  附收 {{ money(scope.row.extraJbAmount) }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="退款" width="96" align="right">
              <template slot-scope="scope">
                <div class="sub">已退 {{ money(scope.row.refundedAmount) }}</div>
                <div class="money-remain">可退 {{ money(scope.row.remainingRefundable) }}</div>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="128" align="center">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="mini"
                  :disabled="!scope.row.canRefund"
                  @click="refundChild(scope.row, true)"
                >关单退</el-button>
                <el-button
                  type="text"
                  size="mini"
                  :disabled="!scope.row.canRefund"
                  @click="refundChild(scope.row, false)"
                >仅退款</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="child-pager">
            <el-pagination
              background
              small
              layout="total, prev, pager, next, sizes"
              :total="childrenTotal"
              :current-page.sync="childFilter.page"
              :page-size.sync="childFilter.size"
              :page-sizes="[10, 20, 50]"
              @current-change="loadChildren"
              @size-change="onChildSizeChange"
            />
          </div>
        </div>

        <p class="tip">
          退款说明：多瓶批量折扣按下单折后实付退；退某一子单不追回其余瓶优惠；运费挂在父单，默认不随单瓶退。
        </p>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import historyTag from "@/components/historyTag";

export default {
  components: { historyTag },
  data() {
    return {
      historyArr: ["订单管理", "父级订单"],
      loading: false,
      detailLoading: false,
      refunding: false,
      tableData: [],
      total: 0,
      query: {
        page: 1,
        size: 20,
        orderNo: "",
        userIdStr: "",
        bizType: "ALL",
        ispay: null,
        freightPayMode: "",
        dateRange: null,
      },
      drawerVisible: false,
      detail: null,
      currentFatherId: null,
      childrenLoading: false,
      childrenList: [],
      childrenTotal: 0,
      childFilter: {
        orderId: "",
        keyword: "",
        bizType: "",
        statusKey: "",
        page: 1,
        size: 50,
      },
    };
  },
  created() {
    this.loadList();
  },
  methods: {
    searchChildren() {
      this.childFilter.page = 1;
      this.loadChildren();
    },
    resetChildFilter() {
      this.childFilter = {
        orderId: "",
        keyword: "",
        bizType: "",
        statusKey: "",
        page: 1,
        size: this.childFilter.size || 10,
      };
      if (this.currentFatherId) {
        this.loadChildren();
      } else {
        this.childrenList = [];
        this.childrenTotal = 0;
      }
    },
    onChildSizeChange() {
      this.childFilter.page = 1;
      this.loadChildren();
    },
    loadChildren() {
      if (!this.currentFatherId) {
        this.childrenList = [];
        this.childrenTotal = 0;
        return;
      }
      const f = this.childFilter;
      const payload = {
        fatherOrderId: this.currentFatherId,
        page: f.page || 1,
        size: f.size || 10,
        orderId: f.orderId || undefined,
        keyword: f.keyword || undefined,
        bizType: f.bizType || undefined,
        statusKey: f.statusKey || undefined,
      };
      this.childrenLoading = true;
      this.$https(this.$api.api.mgmtFatherorderChildren, payload, "POST")
        .then((res) => {
          if (res.data && res.data.code === 200) {
            const list = res.data.data;
            this.childrenList = Array.isArray(list) ? list : [];
            this.childrenTotal = Number(res.data.size) || 0;
          } else {
            this.childrenList = [];
            this.childrenTotal = 0;
            this.$message.error((res.data && res.data.msg) || "子单查询失败");
          }
        })
        .catch(() => {
          this.childrenList = [];
          this.childrenTotal = 0;
          this.$message.error("子单查询网络错误");
        })
        .finally(() => {
          this.childrenLoading = false;
          this.$nextTick(() => {
            const t = this.$refs.childrenTable;
            if (t && typeof t.doLayout === "function") {
              t.doLayout();
            }
          });
        });
    },
    money(v) {
      const n = Number(v);
      if (!Number.isFinite(n)) return "—";
      return "¥" + n.toFixed(2);
    },
    userInitial(row) {
      const name = (row && row.userNickName) || "";
      return name ? String(name).slice(0, 1) : "用";
    },
    freightModeLabel(row) {
      const m = row && row.freightPayMode;
      if (m === "PREPAY") return "预付合单";
      if (m === "POST_PICK") return "取件后付";
      return "";
    },
    bookingStatusLabel(status) {
      const s = status == null ? "" : String(status).trim().toUpperCase();
      if (!s) return "—";
      const map = {
        PENDING: "待预约",
        BOOKING: "预约中",
        BOOKED: "已预约",
        FAILED: "预约失败",
        CANCELLED: "已取消",
        SUCCESS: "已预约",
      };
      return map[s] || status;
    },
    productLabel(row) {
      if (!row) return "—";
      const brand = row.brandName || "";
      const type = row.typeName || "";
      const text = (brand + " " + type).trim();
      return text || "—";
    },
    brandTypeLabel(row) {
      return this.productLabel(row);
    },
    perfumeTip(row) {
      if (!row) return "";
      const main = this.brandTypeLabel(row);
      const svc = row.jbServiceName ? String(row.jbServiceName).trim() : "";
      if (main === "—" && !svc) return "";
      return svc ? main + " · " + svc : main;
    },
    formatPickupAddress(raw) {
      if (raw == null || String(raw).trim() === "") return "—";
      const s = String(raw).trim();
      try {
        const obj = typeof raw === "object" ? raw : JSON.parse(s);
        if (obj && typeof obj === "object") {
          const parts = [
            obj.province,
            obj.city,
            obj.area || obj.district,
            obj.address || obj.detail || obj.addressDetail,
          ].filter((x) => x != null && String(x).trim() !== "");
          if (parts.length) {
            const name = obj.consignee || obj.name || "";
            const phone = obj.telephone || obj.phone || "";
            const contact = [name, phone].filter(Boolean).join(" ");
            return contact ? contact + " · " + parts.join("") : parts.join("");
          }
        }
      } catch (e) {
        /* 非 JSON 原样展示 */
      }
      return s;
    },
    payTagType(row) {
      if (row && Number(row.ispay) === 1) return "success";
      if (row && Number(row.ispay) === 0) return "info";
      return "";
    },
    copyText(text) {
      const v = text == null ? "" : String(text).trim();
      if (!v) return;
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(v).then(
          () => this.$message.success("已复制"),
          () => this.fallbackCopy(v)
        );
      } else {
        this.fallbackCopy(v);
      }
    },
    fallbackCopy(v) {
      const input = document.createElement("input");
      input.value = v;
      document.body.appendChild(input);
      input.select();
      try {
        document.execCommand("copy");
        this.$message.success("已复制");
      } catch (e) {
        this.$message.error("复制失败");
      }
      document.body.removeChild(input);
    },
    lineFee(row) {
      const p = Number(row && row.price) || 0;
      const e = Number(row && row.extraJbAmount) || 0;
      return Math.round((p + e) * 100) / 100;
    },
    formatTime(v) {
      if (!v) return "—";
      const d = new Date(v);
      if (Number.isNaN(d.getTime())) return String(v);
      const pad = (x) => (x < 10 ? "0" + x : "" + x);
      return (
        d.getFullYear() +
        "-" +
        pad(d.getMonth() + 1) +
        "-" +
        pad(d.getDate()) +
        " " +
        pad(d.getHours()) +
        ":" +
        pad(d.getMinutes()) +
        ":" +
        pad(d.getSeconds())
      );
    },
    buildPayload() {
      const q = this.query;
      const payload = {
        page: q.page,
        size: q.size,
        orderNo: q.orderNo || undefined,
        bizType: q.bizType || "ALL",
        freightPayMode: q.freightPayMode || undefined,
      };
      if (q.userIdStr) {
        const uid = parseInt(q.userIdStr, 10);
        if (Number.isFinite(uid)) payload.userId = uid;
      }
      if (q.ispay === 0 || q.ispay === 1) payload.ispay = q.ispay;
      if (q.dateRange && q.dateRange.length === 2) {
        payload.beginTime = q.dateRange[0];
        payload.endTime = q.dateRange[1];
      }
      return payload;
    },
    loadList() {
      this.loading = true;
      this.$https(this.$api.api.mgmtFatherorderList, this.buildPayload(), "POST")
        .then((res) => {
          if (res.data && res.data.code === 200) {
            this.tableData = res.data.data || [];
            this.total = Number(res.data.size) || 0;
          } else {
            this.$message.error((res.data && res.data.msg) || "查询失败");
          }
        })
        .catch(() => this.$message.error("网络错误"))
        .finally(() => {
          this.loading = false;
        });
    },
    searchFn() {
      this.query.page = 1;
      this.loadList();
    },
    resetFn() {
      this.query = {
        page: 1,
        size: 20,
        orderNo: "",
        userIdStr: "",
        bizType: "ALL",
        ispay: null,
        freightPayMode: "",
        dateRange: null,
      };
      this.loadList();
    },
    onSizeChange() {
      this.query.page = 1;
      this.loadList();
    },
    openDetail(row) {
      if (!row || !row.id) return;
      this.currentFatherId = row.id;
      this.resetChildFilterQuiet();
      this.drawerVisible = true;
      this.reloadDetail();
    },
    onDrawerClosed() {
      this.detail = null;
      this.currentFatherId = null;
      this.childrenList = [];
      this.childrenTotal = 0;
      this.resetChildFilterQuiet();
    },
    resetChildFilterQuiet() {
      this.childFilter = {
        orderId: "",
        keyword: "",
        bizType: "",
        statusKey: "",
        page: 1,
        size: this.childFilter.size || 10,
      };
      this.childrenList = [];
      this.childrenTotal = 0;
    },
    reloadDetail() {
      if (!this.currentFatherId) return;
      this.detailLoading = true;
      this.$https(this.$api.api.mgmtFatherorderDetail, { id: this.currentFatherId }, "GET")
        .then((res) => {
          if (res.data && res.data.code === 200) {
            this.detail = res.data.data;
            this.childFilter.page = 1;
            this.loadChildren();
          } else {
            this.$message.error((res.data && res.data.msg) || "加载详情失败");
          }
        })
        .catch(() => this.$message.error("网络错误"))
        .finally(() => {
          this.detailLoading = false;
        });
    },
    postRefund(body) {
      this.refunding = true;
      return this.$https(this.$api.api.mgmtFatherorderRefund, body, "POST")
        .then((res) => {
          if (res.data && res.data.code === 200) {
            this.$message.success((res.data && res.data.msg) || "退款成功");
            this.reloadDetail();
            this.loadList();
            return res;
          }
          this.$message.error((res.data && res.data.msg) || "退款失败");
          return Promise.reject(res);
        })
        .catch((err) => {
          if (err && err.data) return Promise.reject(err);
          this.$message.error("网络错误");
          return Promise.reject(err);
        })
        .finally(() => {
          this.refunding = false;
        });
    },
    refundFreight() {
      const amt = this.detail && this.detail.amounts && this.detail.amounts.freightRemaining;
      this.$prompt("确认退寄件运费金额（元）", "退运费", {
        confirmButtonText: "确认退款",
        cancelButtonText: "取消",
        inputValue: amt != null ? Number(amt).toFixed(2) : "",
        inputPattern: /^\d+(\.\d{1,2})?$/,
        inputErrorMessage: "请输入合法金额",
      })
        .then(({ value }) =>
          this.postRefund({
            fatherOrderId: this.currentFatherId,
            mode: "FREIGHT",
            refundAmount: Number(value),
            refundReason: "寄件运费退款",
          })
        )
        .catch(() => {});
    },
    refundChild(row, closeOrder) {
      if (!row || !row.orderId) return;
      const remain = Number(row.remainingRefundable) || 0;
      const title = closeOrder ? "关单退款" : "仅退款（不关单）";
      this.$prompt(`子单 ${row.orderId}，确认退款金额（元）`, title, {
        confirmButtonText: "确认退款",
        cancelButtonText: "取消",
        inputValue: remain > 0 ? remain.toFixed(2) : "",
        inputPattern: /^\d+(\.\d{1,2})?$/,
        inputErrorMessage: "请输入合法金额",
      })
        .then(({ value }) =>
          this.postRefund({
            fatherOrderId: this.currentFatherId,
            mode: "CHILD",
            childOrderId: row.orderId,
            refundAmount: Number(value),
            closeOrder: !!closeOrder,
            refundReason: closeOrder ? "鉴别服务费退款" : "鉴别服务费部分退款",
          })
        )
        .catch(() => {});
    },
    refundFatherFull() {
      const remain =
        this.detail && this.detail.amounts && this.detail.amounts.remaining != null
          ? Number(this.detail.amounts.remaining)
          : null;
      const remainText =
        remain != null && Number.isFinite(remain) ? "¥" + remain.toFixed(2) : "全部剩余";
      this.$confirm(
        `将一次性退回父单剩余可退金额（约 ${remainText}），关停全部子单。用户微信侧通常只收到一条退款通知。是否继续？`,
        "整单退款",
        { type: "warning", confirmButtonText: "确认整单退款", cancelButtonText: "取消" }
      )
        .then(() =>
          this.postRefund({
            fatherOrderId: this.currentFatherId,
            mode: "FATHER_FULL",
            refundReason: "鉴别订单退款",
          })
        )
        .catch(() => {});
    },
  },
};
</script>

<style scoped>
.father-order-page {
  padding: 12px 16px 24px;
}
.filter-box {
  margin-bottom: 12px;
}
.pager {
  margin-top: 14px;
  text-align: right;
}
.sub {
  color: #999;
  font-size: 12px;
  line-height: 1.4;
}
.sub-row {
  margin-top: 4px;
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}
.order-no {
  color: #303133;
  cursor: pointer;
  font-weight: 500;
  word-break: break-all;
}
.order-no:hover {
  color: #409eff;
}
.user-cell {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}
.user-avatar-img {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
  background: #f0f2f5;
}
.user-avatar-fallback {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  flex-shrink: 0;
  background: #e8eef7;
  color: #5b6b86;
  font-size: 13px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.user-meta {
  min-width: 0;
  flex: 1;
}
.user-name {
  font-size: 13px;
  color: #303133;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.user-phone {
  margin-top: 2px;
  font-size: 12px;
  color: #606266;
  cursor: pointer;
}
.user-phone:hover {
  color: #409eff;
}
.user-phone.muted {
  color: #c0c4cc;
  cursor: default;
}
.money-main {
  font-weight: 600;
  color: #303133;
}
.money-remain {
  color: #c45c26;
  font-size: 12px;
  margin-top: 2px;
}
.goods-brand {
  font-size: 13px;
  color: #303133;
  line-height: 1.35;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.perfume-cell {
  min-width: 0;
  max-width: 100%;
}
.perfume-cell .truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.tag-stack {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}
.mono {
  font-family: Menlo, Monaco, Consolas, "Courier New", monospace;
  font-size: 12px;
}
.detail-wrap {
  padding: 0 18px 28px;
}
.child-section {
  margin-bottom: 8px;
}
.child-table {
  width: 100%;
}
.section-count.soft {
  background: #f7f8fa;
  color: #c0c4cc;
}
.drawer-title-main {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
}
.drawer-title-text {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
  margin-right: 4px;
}
.drawer-title-no {
  margin-top: 4px;
  font-size: 13px;
  color: #409eff;
  cursor: pointer;
  word-break: break-all;
}
.detail-user {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 14px;
  background: #f7f8fa;
  border-radius: 8px;
  margin-bottom: 14px;
}
.detail-user-meta {
  flex: 1;
  min-width: 0;
}
.detail-user-sub {
  margin-top: 4px;
  font-size: 12px;
  color: #909399;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px;
}
.detail-user-side {
  text-align: right;
  flex-shrink: 0;
}
.side-label {
  font-size: 12px;
  color: #909399;
}
.side-value {
  margin-top: 2px;
  font-size: 15px;
  font-weight: 600;
  color: #303133;
}
.amount-bar {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 14px;
}
.amount-bar .amt {
  min-width: 112px;
  flex: 1;
  background: #f7f8fa;
  border-radius: 8px;
  padding: 10px 12px;
}
.amount-bar .amt span {
  display: block;
  color: #909399;
  font-size: 12px;
}
.amount-bar .amt b {
  display: block;
  margin-top: 4px;
  font-size: 16px;
  color: #303133;
}
.amount-bar .amt-hl {
  background: #fff7f0;
}
.amount-bar .amt-hl b {
  color: #c45c26;
}
.section-card {
  border: 1px solid #ebeef5;
  border-radius: 8px;
  padding: 12px 14px 14px;
  margin-bottom: 14px;
}
.section-title {
  font-size: 14px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  gap: 6px;
}
.section-count {
  font-size: 12px;
  font-weight: 500;
  color: #909399;
  background: #f0f2f5;
  border-radius: 10px;
  padding: 0 8px;
  line-height: 20px;
}
.child-filter {
  margin-bottom: 8px;
}
.child-filter .el-form-item {
  margin-bottom: 8px;
}
.child-pager {
  margin-top: 10px;
  padding-top: 4px;
  text-align: right;
}
.info-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px 16px;
}
.info-item {
  display: flex;
  gap: 8px;
  min-width: 0;
  font-size: 13px;
  line-height: 1.5;
}
.info-item-full {
  grid-column: 1 / -1;
}
.info-item .k {
  flex-shrink: 0;
  width: 64px;
  color: #909399;
}
.info-item .v {
  color: #303133;
  word-break: break-all;
}
.info-item .v.err {
  color: #f56c6c;
}
.linkish {
  color: #409eff;
  cursor: pointer;
}
.linkish:hover {
  text-decoration: underline;
}
.muted {
  color: #c0c4cc;
}
.dot {
  color: #dcdfe6;
}
.actions {
  margin: 0 0 14px;
}
.tip {
  margin-top: 4px;
  color: #909399;
  font-size: 12px;
  line-height: 1.6;
}
</style>

<style>
/* custom-class 挂在 drawer 根节点，需非 scoped */
.father-detail-drawer {
  display: flex;
  flex-direction: column;
}
.father-detail-drawer .el-drawer__header {
  margin-bottom: 12px;
  padding: 16px 18px 0;
}
.father-detail-drawer .el-drawer__body {
  flex: 1;
  overflow-y: auto;
  padding-bottom: 20px;
  -webkit-overflow-scrolling: touch;
}
</style>



// WEBPACK FOOTER //
// src/pages/goodsOrder/fatherOrder.vue